import { SavedAudienceStandardTargetingSpec } from '../../facebook/audience';

export interface MMGeneratedAudienceDTO {
  name: string;
  description?: string;
  isDefault: boolean;
  targetingSpec: SavedAudienceStandardTargetingSpec;
  selectedStageID: number;
  autoUpdate: boolean;
}

export interface CreateCustomListAudienceDTO {
  name: string;
  description?: string;
}

export interface CreateCustomListAudienceResponse {
  id: string;
}

export type UpdateCustomListAudienceDTO = Array<Array<string | null>>;

export interface UpdateCustomListAudienceResponse {
  audience_id: string;
  session_id: string;
  num_received: number;
  num_invalid_entries: number;
  invalid_entry_samples: { [key: string]: any };
}

export const customListAudienceMatchKeySchema = [
  'EMAIL',
  'PHONE',
  'GEN',
  'DOBY',
  'DOBM',
  'DOBD',
  'LN',
  'FN',
  'FI',
  'CT',
  'ST',
  'ZIP',
  'COUNTRY',
];
